export interface TradeTemplate {
  id: string;
  name: string;
  icon: string;
  color: string;
  labourItems: string[];
  csvPath: string;
  fileName: string;
}

export const TRADE_TEMPLATES: TradeTemplate[] = [
  {
    id: 'bricklaying',
    name: 'Bricklaying',
    icon: 'Construction',
    color: '#E65100',
    labourItems: ['Brickwork 1st Lift', 'Brickwork 2nd Lift', 'Brickwork Top'],
    csvPath: '/templates/bricklaying.csv',
    fileName: 'bricklaying-template.csv',
  },
  {
    id: 'joinery',
    name: 'Joinery',
    icon: 'Carpenter',
    color: '#5D4037',
    labourItems: ['Joinery 1st Fix', 'Joinery 2nd Fix'],
    csvPath: '/templates/joinery.csv',
    fileName: 'joinery-template.csv',
  },
  {
    id: 'plumbing',
    name: 'Plumbing',
    icon: 'Plumbing',
    color: '#1565C0',
    labourItems: ['Plumbing 1st Fix', 'Plumbing 2nd Fix'],
    csvPath: '/templates/plumbing.csv',
    fileName: 'plumbing-template.csv',
  },
  {
    id: 'electrical',
    name: 'Electrical',
    icon: 'ElectricalServices',
    color: '#F9A825',
    labourItems: ['Cables 1st Fix', 'Cables 2nd Fix', 'Electrical Testing'],
    csvPath: '/templates/electrical.csv',
    fileName: 'electrical-template.csv',
  },
  {
    id: 'timber-frame',
    name: 'Timber Frame',
    icon: 'Foundation',
    color: '#2E7D32',
    labourItems: ['Timber Frame Kit'],
    csvPath: '/templates/timber-frame.csv',
    fileName: 'timber-frame-template.csv',
  },
  {
    id: 'window-fitting',
    name: 'Window Fitting',
    icon: 'Window',
    color: '#0277BD',
    labourItems: [
      'Window Installation',
      'Door Installation',
      'Window Board Installation',
      'Final Clean',
    ],
    csvPath: '/templates/window-fitting.csv',
    fileName: 'window-fitting-template.csv',
  },
  {
    id: 'plastering',
    name: 'Plastering',
    icon: 'FormatPaint',
    color: '#546E7A',
    labourItems: [
      'Wet Plastering',
      'Dry Lining',
      'Ceiling Skim',
      'Protection and Preparation',
      'Final Snagging',
    ],
    csvPath: '/templates/plastering.csv',
    fileName: 'plastering-template.csv',
  },
];
